import React, { useEffect, useState } from "react";
import { Button, Col, Form, Input, Row, Table } from "antd";
import { DeleteOutlined } from '@ant-design/icons';
import EditableCell from "./EditableCell";
import EditableRow from "./EditableRow";
import { TfiMenuAlt } from "react-icons/tfi";
import EventEmitter from "../utils/eventEmitter";





const EditableTable = ({dataSource, pos, attributes, values, setDataSource, columns, addLine, dependant, products, taxes, contacts, option1, option2, disabled, apiDelete, disableSummary }) => {
  const [taxPrice, setTaxPrice] = useState([]);
  const [lineTaxes, setLineTaxes] = useState([]);

  const handleDelete = (e, record) => {
    const key = record.key;
    e.preventDefault();
    e.stopPropagation();
    const newData = dataSource.filter((item) => item.key !== key);
    const taxPrice_ = taxPrice.filter(item => item.id !== key);
    
    setTaxPrice(taxPrice_);
    if (apiDelete && record.id) {
      apiDelete(record.id);
      // console.log('DELETED!!!')
    }
    setDataSource(newData);
  };
  
  const calculateTaxPrice = (subtotal, taxes, key) => {
    let taxPrice_ = [...taxPrice];
    taxes.forEach(taxObj => {
      let taxIndex = taxPrice.findIndex(tax => tax.name === taxObj.label);
      let lineTax = dataSource[key].taxes.findIndex(tax => tax === taxObj.value);
      // console.log(taxIndex, taxes);
      if (taxIndex === -1 || lineTax === -1) {
        let taxObj_ = {name: taxObj.label, value: taxObj.value, id: taxObj.id};
        switch (taxObj.computation) {
          case 'percent_of_price':
            taxObj_['amount'] = (parseFloat(taxObj.amount / 100) * subtotal).toFixed(2) * 1;
            break;
          case 'percent_of_price_included':
            taxObj_['amount'] = (parseFloat(subtotal / 1 - (taxObj.amount / 100))).toFixed(2) * 1;
            // setTax(prev => prev + taxEntryObj['amount']);
            break;
          case 'fixed':
            taxObj_['amount'] = (parseFloat(subtotal + taxObj.amount )).toFixed(2) * 1;
            // setTax(prev => prev + taxEntryObj['amount']);
            break;
        };
        taxPrice_.push(taxObj_);
        console.log('running')
      }else {
        // console.log(taxIndex, taxObj)
        // dataSource[key].taxes.forEach(lineTax => {
        //   console.log(taxPrice_[taxIndex], lineTax)
        //   if (taxPrice_[taxIndex].value !== lineTax) {
        //     switch (taxObj.computation) {
        //     case 'percent_of_price':
        //       taxPrice[taxIndex]['amount'] += (parseFloat(taxObj.amount / 100) * subtotal).toFixed(2) * 1;
        //       break;
        //     case 'percent_of_price_included':
        //       taxPrice[taxIndex]['amount'] += (parseFloat(subtotal / 1 - (taxObj.amount / 100))).toFixed(2) * 1;
        //       // setTax(prev => prev + taxEntryObj['amount']);
        //       break;
        //     case 'fixed':
        //       taxPrice[taxIndex]['amount'] += (parseFloat(subtotal + taxObj.amount )).toFixed(2) * 1;
        //       // setTax(prev => prev + taxEntryObj['amount']);
        //       break;
        //     };
        //   }else {
        //     console.log('testing: ', taxIndex)
        //   }
        // })
      }
    })
    setTaxPrice(taxPrice_);
  }

  const handleSave = (row, form) => {
    const newData = [...dataSource];
    let tax = form.getFieldValue('tax_id');
    const index = newData.findIndex((item) => row.key === item.key);
    let item = newData[index];
    // if (item.description || item.label) row.description = form.getFieldValue('description');
    
    if (form.getFieldValue('description') !== undefined) {
      row['description'] = form.getFieldValue('description');
      row['price'] = row.price ? row.price : form.getFieldValue('price')
    }
    if (item.subtotal !== undefined) {
      row.subtotal = row.quantity * row.price;
    }
    if (form.getFieldValue('taxes'+row.key) !== undefined && row.subtotal > 0) {
      let taxes = form.getFieldValue('taxes'+row.key);
      calculateTaxPrice(row.subtotal, taxes, row.key);
    }
    // if (tax !== undefined) {
    //   row['tax_id'] = tax;
    // }
    newData.splice(index, 1, {...item, ...row});
    setDataSource(newData);
    if (dependant) EventEmitter.dispatch('to_another_table', item);
  };


  // console.log(taxPrice)

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  const handleMenu = () => { };

  useEffect(() => {
    EventEmitter.subscribe('remove_tax', data => {
      // const { key, taxes } = data;
      let taxPrice_ = [...taxPrice];
      let filteredTax = [];
      taxPrice_.forEach(tax => {
        if (tax.id === data.id) {

        }else {
          filteredTax.push(tax);
        }
      });
      console.log(taxPrice_)
      setTaxPrice(filteredTax);
      
    });

    return () => EventEmitter.unsubscribe('remove_tax');
  },[])
  // console.log(taxPrice)
  // calculateTaxPrice(row, taxes);

  useEffect(() => {
    const groupedData = taxPrice.reduce((acc, current) => {
      // Check if the category already exists in the accumulator
      if (!acc[current.name]) {
        // If not, initialize it with an object containing the category and amount
        acc[current.name] = { name: current.name, amount: 0 };
      }
      // Add the current amount to the total amount for the category
      acc[current.name].amount += current.amount;
      // Return the accumulator for the next iteration
      return acc;
    }, {});
    const result = Object.values(groupedData);
    setLineTaxes(result);
    EventEmitter.dispatch('tax_total_price', result);
  },[taxPrice])

  columns[columns.length -1 ]['render'] = (_, record) => 
    <div>
      <Button className="border-0 me-2 text-[#189aa0] hover:text-[#189aa0]" onClick={handleMenu} icon={<TfiMenuAlt />}/>
      <Button className="border-0" danger onClick={(e)=>handleDelete(e, record)} icon={<DeleteOutlined />}/>
    </div>

  if (disabled) delete columns[columns.length - 1]['render']

  const mergeColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        readOnly: col.readOnly,
        handleSave,
        inputType: (col.dataIndex.includes('location') || col.dataIndex.includes('_id')) ? 'select' : 
          (col.dataIndex.includes('quantity') || col.dataIndex === 'price') ? 'number' : 
          (col.dataIndex === 'taxes') ? 'tags' : 'text',
        options: 
          col.dataIndex === 'pos_id' && pos.map(item => ({value: item.id, label: item.name})) ||
          col.dataIndex === 'product_id' && products.map(product => ({value: product.id, label: product.name, cost: product.cost_price ? product.cost_price : product.sales_price, tax_id: product.tax_id})) ||
          (col.dataIndex === 'contact_id' || col.dataIndex === 'vendor_id') && contacts.map(contact => ({value: contact.id, label: contact.name})) ||
          col.dataIndex === 'attribute_id' && attributes.map(attribute => ({value: attribute.id, label: attribute.name, values: attribute.values})) ||
          // (col.dataIndex === 'value_id') && values.map(value => ({value: value.value})) ||
          col.dataIndex === 'tax_id' && taxes.map(tax => ({value: tax.id, label: tax.name})) ||
          // col.dataIndex === 'taxes' && taxes.map(tax => ({value: tax._id, label: tax.name, amount: tax.amount, computation: tax.tax_computation, id: record.key})) ||
          col.dataIndex.includes('location') && option1.map(location => ({value: location.id, label: `${location.name}`})) ||
          col.dataIndex === 'lot_serial_number_id' && [] ||
          col.dataIndex === 'outstanding_account_id' && option2.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))
      }),
    };
  });
  return (
    <div>
      <Table
        components={components}
        rowClassName={() => 'editable-row'}
        bordered
        dataSource={dataSource}
        columns={mergeColumns}
        pagination = {false}
        size="small"
      />
      {!disabled && <Button onClick={addLine} className="border-0">
        Add a line
      </Button>}
      
    </div>
  );
};


EditableTable.defaultProps = {
  contacts: []
}

export default EditableTable;